import { chunk, isEmpty } from "lodash";
import RestAPIClient from "services/RestAPIClient";
import { IPageableData } from "services/typings";
import { ITranslateItem, ITranslateRequest } from "./typings";

class LanguageService extends RestAPIClient {
  constructor() {
    super("languages", false);
  }

  getTranslateItems = async (
    req: ITranslateRequest
  ): Promise<IPageableData<ITranslateItem>> => {
    const { filters, ...rest } = req;
    const res = await this.get(`/public`);
    return {
      data: res.data,
      total: res.pagination.total,
    };
  };

  update = async (req: ITranslateItem) => {
    await this.post("/admin/save", req);
    return null;
  };

  deleteTranslateItems = async (keys?: string[]) => {
    if (isEmpty(keys)) return null;
    await this.delete("/admin/delete", { keys });
    return null;
  };

  updateTranslateItems = async (
    req: ITranslateItem[],
    deletedKeys?: string[]
  ): Promise<null> => {
    await Promise.all([
      this.post("/admin/bulk", req),
      this.deleteTranslateItems(deletedKeys),
    ]);
    return null;
  };
}

export default new LanguageService();
